import { render, staticRenderFns } from "./VisualizarDocumento.vue?vue&type=template&id=1952a59a&scoped=true"
import script from "./VisualizarDocumento.vue?vue&type=script&lang=js"
export * from "./VisualizarDocumento.vue?vue&type=script&lang=js"
import style0 from "./VisualizarDocumento.vue?vue&type=style&index=0&id=1952a59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952a59a",
  null
  
)

export default component.exports